/* eslint-disable no-lone-blocks */
import React, { Suspense, lazy, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { LayoutSplashScreen } from "../../../_metronic";
import { AUTH_TOKEN_KEY } from "../../config/auth";
import makeRequest from "../../../app/libs/request";
{
	/* =============Dashboard============= */
}
const Dashboard = lazy(() => import("../dashboard/Dashboard"));

const Error403 = lazy(() => import("../common/Error403"));
{
	/* ==================================== */
}
const ListCategory = lazy(() => import("../category/ListCategory"));
const ListLevel = lazy(() => import("../level/ListLevel"));
const ListDepartment = lazy(() => import("../department/ListDepartment"));
const ListCourse = lazy(() => import("../course/ListCourse"));
const ListCourseCB = lazy(() => import("../course/ListCourseCB"));
const CreateCourse = lazy(() => import("../course/CreateCourse"));
const EditCourse = lazy(() => import("../course/EditCourse"));
const ViewCourse = lazy(() => import("../course/ViewCourse"));
const Analytics = lazy(() => import("../course/Analytics"));
const Attended = lazy(() => import("../course/Attended"));
const AnalyticExam = lazy(() => import("../course/AnalyticExam"));
const PreviewExam = lazy(() => import("../course/preview/PreviewExam"));
const ListUserSub = lazy(() => import("../users/sub_user/ListUser"));
const CreateUserSub = lazy(() => import("../users/sub_user/CreateUser"));
const EditUserSub = lazy(() => import("../users/sub_user/EditUser"));
const EditRowCorporateUser = lazy(() => import("../corporate/EditRowCorporateUser"));
const ListPromotion = lazy(() => import("../promotions/ListPromotion"));
const CreatePromotion = lazy(() => import("../promotions/CreatePromotion"));
const EditPromotion = lazy(() => import("../promotions/EditPromotion"));
const SaleReport = lazy(() => import("../report/sale/SaleReport"));
// const ViewPromotion = lazy(() => import("../promotions/ViewPromotion"));
const ListOrder = lazy(() => import("../orders/ListOrder"));
const ViewOrder = lazy(() => import("../orders/ViewOrder"));
const ListInquiry = lazy(() => import("../inquiry/ListInquiry"));
const ViewInquiry = lazy(() => import("../inquiry/ViewInquiry"));
const ListTranning = lazy(() => import("../trannings/ListTranning"));
const CreateTranning = lazy(() => import("../trannings/CreateTranning"));
const EditTranning = lazy(() => import("../trannings/EditTranning"));
const ListCorporate = lazy(() => import("../corporate/ListCorporate"));
const CreateCorporate = lazy(() => import("../corporate/CreateCorporate"));
const EditCorporate = lazy(() => import("../corporate/EditCorporate"));
const DetailCorporate = lazy(() => import("../corporate/DetailCorporate"));
const EditCorporateCourse = lazy(() => import("../corporate/EditCorporateCourse"));
const EditCorporateDepartment = lazy(() => import("../corporate/EditCorporateDepartment"));
const CreateCorUserTab = lazy(() => import("../corporate/CreateCorUserTab"));
const EditCorporateUser = lazy(() => import("../corporate/EditCorporateUser"));
const CorporatePaymentTab = lazy(() => import("../corporate/CorporatePaymentTab"));
const CorporateBillingList = lazy(() => import("../corporate/BillingList"));
const CorStorageDetail = lazy(() => import("../corporate/StorageDetail"));
const ListMass = lazy(() => import("../mass/ListMass"));
const CreateMass = lazy(() => import("../mass/CreateMass"));
const ViewMass = lazy(() => import("../mass/ViewMail"));
const UseMail = lazy(() => import("../mass/UseMail"));
const EditMass = lazy(() => import("../mass/EditMass"));
const ListAdmin = lazy(() => import("../admin/ListUser"));
const CreateAdmin = lazy(() => import("../admin/CreateUser"));
const EditAdmin = lazy(() => import("../admin/EditUser"));
const ListMarker = lazy(() => import("../users/marker/ListUser"));
const CreateMarker = lazy(() => import("../users/marker/CreateUser"));
const EditMarker = lazy(() => import("../users/marker/EditUser"));
const Report = lazy(() => import("../report"));
const ListExam = lazy(() => import("../quiz/ListExam"));
const CreateExam = lazy(() => import("../quiz/CreateExam"));
const EditExam = lazy(() => import("../quiz/EditExam"));
const SubcriptionPlan = lazy(() => import("../home/SubcriptionPlan"));
const Payment = lazy(() => import("../payment/PaymentInfo"));
const UpdatePlan = lazy(() => import("../payment/UpdatePlan"));
const BillingList = lazy(() => import("../payment/BillingList"));
const UpdateCard = lazy(() => import("../payment/UpdateCard"));
const StorageDetail = lazy(() => import("../payment/StorageDetail"));
// const MyCompany = lazy(() => import("../home/MyCompany"));
const ListPlan = lazy(() => import("../plan/ListPlan"));
const CreatePlan = lazy(() => import("../plan/CreatePlan"));
const EditPlan = lazy(() => import("../plan/EditPlan"));
const StripeAccount = lazy(() => import("../payment/StripeAccount"));
const TransferLog = lazy(() => import("../payment/TransferLog"));
const Appearance = lazy(() => import("../website/Appearance"));
const Policy = lazy(() => import("../static-page/Policy"));
const Condition = lazy(() => import("../static-page/Condition"));
const ListQuestionBank = lazy(() => import("../question-bank/ListQuestion"));
const CreateQuestion = lazy(() => import("../question-bank/CreateQuestion"));
const EditQuestion = lazy(() => import("../question-bank/EditQuestion"));
const DashboardMarker = lazy(() => import("../dashboard/DashboardMarker"));
const DetailProgress = lazy(() => import("../dashboard/DetailProgress"));
const ListCompany = lazy(() => import("../company/ListCompany"));
const DetailCompany = lazy(() => import("../company/DetailCompany"));
const PreviewQuiz = lazy(() => import("../quiz/Preview"));
const ExamResponse = lazy(() => import("../course/response/Exam"));
const DetailResponse = lazy(() => import("../course/response/Detail"));
const ListRole = lazy(() => import("../roles/ListRole"));
const EditRole = lazy(() => import("../roles/EditRole"));
const CreateRole = lazy(() => import("../roles/CreateRole"));
const Agent = lazy(() => import("../agent/ListAgent"));
const InviteAgent = lazy(() => import("../agent/InviteAgent"));
const EditAgent = lazy(() => import("../agent/EditAgent"));
const ReferralList = lazy(() => import("../referral/ListReferral"));


const CreateBuilder = lazy(() => import("../course-builder/CreateBuilder"));
const ListBuilder = lazy(() => import("../course-builder/ListBuilder"));
const UpdateBuilder = lazy(() => import("../course-builder/UpdateBuilder"));
const PreviewBuilder = lazy(() => import("../course-builder/PreviewBuilder"));

// const CompanyProfile = lazy(() => import("../website/CompanyProfile"));

export default function HomePage() {
	const [isAdmin, setIsAdmin] = useState(true);
	// const [role, setRole] = useState("");
	setTimeout(() => {
		if (localStorage.getItem(AUTH_TOKEN_KEY)) {
			let auth = JSON.parse(localStorage.getItem(AUTH_TOKEN_KEY));
			if (auth && auth.authToken) {
				const token = JSON.parse(auth.authToken);
				makeRequest("get", `user/userInfo?token=${token}`)
					.then(({ data }) => {
						if (data.signal) {
							setIsAdmin(data.data.is_manager);
							// setRole(data.data.role_admin);
						}
					})
					.catch((err) => {
						console.log(err);
					});
			}
		}
	}, 500);
	if (isAdmin) {
		return (
			<Suspense fallback={<LayoutSplashScreen />}>
				<Switch>
					{
						/* Redirect from root URL to /dashboard. */
						<Redirect exact from="/" to="/dashboard" />
					}
					{/* Route other */}
					<Route path="/subscription-plan" component={SubcriptionPlan} />
					<Route path="/stripe-account" component={StripeAccount} />
					<Route path="/dashboard" component={Dashboard} />
					<Route path="/Error403" component={Error403} />
					<Route path="/industry/list" component={ListCategory} />
					<Route path="/level/list" component={ListLevel} />
					<Route path="/courses/list" component={ListCourse} />
					<Route path="/courses-cb/list" component={ListCourseCB} />
					<Route path="/course/create" component={CreateCourse} />
					<Route path="/course/edit/:id" component={EditCourse} />
					<Route path="/course/view/:id" component={ViewCourse} />
					<Route path="/course/attendeed/:id" component={Attended} />
					<Route path="/course/detail/:id/analytic-exam/:exam_id" component={AnalyticExam} />
					<Route path="/course/:id/preview-exam/:exam_id/version/:version_id" component={PreviewExam} />
					<Route path="/course/analytics" component={Analytics} />
					<Route path="/promotion/list" component={ListPromotion} />
					<Route path="/promotion/create" component={CreatePromotion} />
					<Route path="/promotion/edit/:id" component={EditPromotion} />
					<Route path="/order/list" component={ListOrder} />
					<Route path="/order/view/:id" component={ViewOrder} />
					<Route path="/inquiry/list" component={ListInquiry} />
					<Route path="/inquiry/view/:id" component={ViewInquiry} />
					<Route path="/training/list" component={ListTranning} />
					<Route path="/training/create" component={CreateTranning} />
					<Route path="/training/edit/:id" component={EditTranning} />
					<Route path="/corporate/list" component={ListCorporate} />
					<Route path="/company/list" component={ListCompany} />
					<Route path="/company/detail/:id" component={DetailCompany} />
					<Route path="/corporate/create" component={CreateCorporate} />
					<Route path="/corporate-tab/edit/:id" component={EditCorporate} />
					<Route path="/corporate-tab/detail/:id" component={DetailCorporate} />
					<Route path="/corporate-course-tab/edit/:id" component={EditCorporateCourse} />
					<Route path="/department-tab/edit/:id" component={EditCorporateDepartment} />
					<Route path="/corporate-user-tab/create/:id" component={CreateCorUserTab} />
					<Route path="/corporate-user-tab/edit/:id" component={EditCorporateUser} />
					<Route path="/corporate-user-row-tab/edit/:corporate_id/user/:id" component={EditRowCorporateUser} />
					<Route path="/corporate-payment-tab/edit/:id" component={CorporatePaymentTab} />
					<Route path="/corporate-billing/:id" component={CorporateBillingList} />
					<Route path="/corporate-storage/:id" component={CorStorageDetail} />
					<Route path="/mass-comm/list" component={ListMass} />
					<Route path="/mass-comm/create" component={CreateMass} />
					<Route path="/mass-comm/view/:id" component={ViewMass} />
					<Route path="/mass-comm/use/:id" component={UseMail} />
					<Route path="/mass-comm/edit/:id" component={EditMass} />

					<Route path="/admin/list" component={ListAdmin} />
					<Route path="/admin/create" component={CreateAdmin} />
					<Route path="/admin/edit/:id" component={EditAdmin} />
					<Route path="/users/list" component={ListUserSub} />
					<Route path="/users/create" component={CreateUserSub} />
					<Route path="/users/edit/:id" component={EditUserSub} />
					<Route path="/department/list" component={ListDepartment} />
					<Route path="/report" component={Report} />
					<Route path="/quiz/list" component={ListExam} />
					<Route path="/quiz/create" component={CreateExam} />
					<Route path="/quiz/edit/:id" component={EditExam} />
					<Route path="/quiz/preview/:id" component={PreviewQuiz} />
					<Route path="/payment" component={Payment} />
					<Route path="/change-subscription-plan" component={UpdatePlan} />
					<Route path="/billing-activity" component={BillingList} />
					<Route path="/change-payment-method" component={UpdateCard} />
					<Route path="/storage-detail" component={StorageDetail} />
					<Route path="/transfer-log" component={TransferLog} />

					<Route path="/plan/list" component={ListPlan} />
					<Route path="/plan/create" component={CreatePlan} />
					<Route path="/plan/edit/:id" component={EditPlan} />
					<Route path="/appearance" component={Appearance} />
					<Route path="/policy" component={Policy} />
					<Route path="/condition" component={Condition} />
					<Route path="/marker/list" component={ListMarker} />
					<Route path="/marker/create" component={CreateMarker} />
					<Route path="/marker/edit/:id" component={EditMarker} />
					<Route path="/question-bank/list" component={ListQuestionBank} />
					<Route path="/question-bank/create" component={CreateQuestion} />
					<Route path="/question-bank/edit/:id" component={EditQuestion} />
					<Route path="/sales-report" component={SaleReport} />
					<Route path="/course/:id/user/:user_id" component={ExamResponse} />
					<Route path="/course/:id/user-data/:user_id/item/:progress_id" component={DetailResponse} />
					<Route path="/role/list" component={ListRole} />
					<Route path="/role/edit/:id" component={EditRole} />
					<Route path="/role/create" component={CreateRole} />
					<Route path="/agent/list" component={Agent} />
					<Route path="/agent/invite" component={InviteAgent} />
					<Route path="/agent/edit/:id" component={EditAgent} />
					<Route path="/referral/list" component={ReferralList} />
					<Route path="/course-builder/list" component={ListBuilder} />
					<Route path="/course-builder/create" component={CreateBuilder} />
					<Route path="/course-builder/edit/:id" component={UpdateBuilder} />
					<Route path="/course-builder/preview/:id" component={PreviewBuilder} />
				</Switch>
			</Suspense>
		);
	} else
		return (
			<Suspense fallback={<LayoutSplashScreen />}>
				<Switch>
					{
						/* Redirect from root URL to /dashboard. */
						<Redirect exact from="/" to="/dashboard" />
					}
					{/* Route other */}
					<Route path="/dashboard" component={DashboardMarker} />
					{/* <Redirect to="Error403" /> */}
					<Route path="/Error403" component={Error403} />
					<Route path="/detail-progress/:id" component={DetailProgress} />
				</Switch>
			</Suspense>
		);
}
